<template>
  <main>
    <SCMOnHandsFilterComponent
      :loading="loadingRelatedData || loadingTable"
      :subInventories="subInventories"
    />

    <v-container>
      <v-toolbar flat class="main-header mb-6">
        <v-toolbar-title class="main-header__title">
          <h1>{{ $t("label.onHands") }}</h1>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-toolbar-items class="main-header__contents">
          <v-btn
            class="my-auto mx-2 radius-50"
            color="primary"
            icon
            :title="$t('changeLocale')"
            @click="changeLocale"
          >
            <v-icon> mdi-web </v-icon>
          </v-btn>
          <download-excel :data="scmOnHands" :fields="json_fields">
            <v-btn outlined color="red" large class="mt-3"
              ><v-icon class="mr-3">mdi-cloud-download</v-icon>Export</v-btn
            >
          </download-excel>
        </v-toolbar-items>
      </v-toolbar>
      <hr class="mb-6" />

      <v-data-table
        :headers="scmOnHandsTableHeaders"
        :loading="loadingTable"
        :items="scmOnHands"
        :mobile-breakpoint="0"
        :items-per-page="200"
        hide-default-footer
        class="table"
      >
        <template v-slot:item="{ item }">
          <tr class="table__row">
            <td class="table__cell text-center">
              <span> {{ (item.item && item.item.code) || "-" }} </span>
            </td>

            <td class="table__cell name text-center">
              <span> {{ (item.item && item.item.name) || "-" }} </span>
            </td>

            <td class="table__cell text-center">
              <span> {{ item.on_hand_qty || "-" }} </span>
            </td>

            <td class="table__cell text-center">
              <span>
                {{
                  (item.item &&
                    item.item.unit_of_measure &&
                    item.item.unit_of_measure.name) ||
                  "-"
                }}
              </span>
            </td>

            <td class="table__cell text-center">
              <span>
                {{ (item.inventory && item.inventory.name) || "-" }}
              </span>
            </td>

            <td class="table__cell text-center">
              <span> {{ item.locator_name || "-" }} </span>
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- pagination -->
      <div class="text-xs-center pt-2">
        <v-pagination
          v-if="pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="20"
          @input="handlePagination"
        ></v-pagination>
      </div>
      <!-- pagination -->
    </v-container>
  </main>
</template>

<script>
import i18n from "@/lang";
import { IndexData } from "@/helpers/apiMethods";
import { isEqual } from "lodash";
import SCMOnHandsFilterComponent from "./components/scmOnHandsFilter.component";

export default {
  components: {
    SCMOnHandsFilterComponent,
  },
  data() {
    return {
      json_fields: {
        code: {
          field: "item.code",
        },
        name: {
          field: "item.name",
        },
        "on Hand": {
          field: "on_hand_qty",
        },
        "primary UOM": {
          field: "item.unit_of_measure.name",
        },
        "sub Inventory": {
          field: "inventory.name",
        },
        locator: {
          field: "locator_name",
        },
      },
      scmOnHands: [],
      subInventories: [],
      pagination: {},
      queries: {},
      loadingTable: false,
      loadingRelatedData: false,
    };
  },
  async mounted() {
    await this.indexSCMOnHandsRelatedData();
  },
  computed: {
    scmOnHandsTableHeaders() {
      return [
        {
          text: this.$t("table.itemCode"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("table.name"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("table.onHands"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("table.primaryUOM"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("table.subInventory"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("table.locator"),
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    changeLocale() {
      i18n.locale = i18n.locale === "en" ? "ar" : "en";
    },
    indexSCMOnHands(query) {
      this.loadingTable = true;
      IndexData({ reqName: "scm/on-hands", query })
        .then((res) => {
          const { data, meta } = res.data;
          this.scmOnHands = data;
          this.pagination = meta;
        })
        .catch(() => {
          console.log();
        })
        .finally(() => {
          this.loadingTable = false;
        });
    },

    async indexSCMOnHandsRelatedData() {
      try {
        this.loadingRelatedData = true;
        const subInventoriesRes = await IndexData({
          reqName: "scm/inventories",
        });

        this.subInventories =
          subInventoriesRes && subInventoriesRes.data
            ? subInventoriesRes.data.data.map((subInventor) => ({
                ...subInventor,
                id: subInventor.id.toString(),
              }))
            : [];
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingRelatedData = false;
      }
    },
    handlePagination(page) {
      this.queries = { ...this.queries, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
  },
  watch: {
    $route: {
      handler(route) {
        const { query } = route;
        this.queries = query;
        this.indexSCMOnHands(query);
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.v-data-table .table__row td i.mdi-eye {
  color: #212121 !important;
}
</style>
